module.exports = __webpack_public_path__ + "img/gb-wls.8742b3d.svg";